/**
 * Shape a Care Watch signal into the timesheet row the confirm modal labels.
 */
export const careWatchSignalToTimesheetRow = (item) => {
  if (!item) return null;

  const workerRef = item.workerRef;
  let worker = null;
  if (workerRef) {
    worker = {
      first_name: workerRef.firstName || "",
      last_name: workerRef.lastName || "",
    };
  } else if (typeof item.worker === "string") {
    const parts = item.worker.trim().split(/\s+/).filter(Boolean);
    worker = {
      first_name: parts[0] || "",
      last_name: parts.slice(1).join(" "),
    };
  } else if (item.worker && typeof item.worker === "object") {
    worker = {
      first_name: item.worker.first_name || item.worker.firstName || "",
      last_name: item.worker.last_name || item.worker.lastName || "",
    };
  }

  const participants = (item.participants || []).map((person) => ({
    first_name: person.firstName || person.first_name || "",
    last_name: person.lastName || person.last_name || "",
  }));

  return {
    id: item.timesheetId,
    worker,
    participants,
    time_sheet_date: item.shiftDate,
  };
};
